// React & libs
import { useState, useEffect } from 'react';
import { Card, Col, Dropdown, Row } from 'react-bootstrap';

// Shared UI
import ChildrensTooltip from '@/components/common/ChildrensTooltip';

// Assets
import logo_binesh from '@/assets/img/logo-binesh.svg';
import mizfa_logo from '@/assets/img/mizfa-tools-no-text.svg';

// -----------------------------------------------------------------------------
// Types
// -----------------------------------------------------------------------------

interface QuickLinkItemProps {
  img?: string;
  title: string;
  link: string;
  index?: number;
}

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

/**
 * منوی نه نقطه در هدر: دسترسی سریع به حساب کاربری، میزفا تولز و وبینش.
 */
const NineDotMenu = () => {
  // ----- state -----
  const [show, setShow] = useState<boolean | null>(null);

  // ----- data -----
  const quickLinks: QuickLinkItemProps[] = [
    {
      img: logo_binesh,
      title: 'حساب کاربری',
      link: 'https://accounts.binesh-ec.com/'
    },
    {
      img: mizfa_logo,
      title: 'میزفا تولز',
      link: 'https://panel.mizfa.tools/'
    },
    {
      img: 'https://static.webinesh.ir/webinesh/logo/logo.svg',
      title: 'وبینش',
      link: 'https://panel.webinesh.ir/'
    }
  ];

  // ----- effects -----
  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth < 1200) {
        setShow(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // ----- render -----
  return (
    <ChildrensTooltip
      delayToRemove={100}
      placement="bottom"
      showOnHover={false}
      html={show ? undefined : 'پلتفرم‌های بینش'}
    >
      <Dropdown navbar={true} as="span" show={show ?? undefined} onToggle={() => setShow(!show)}>
        {/* دکمه نه نقطه */}
        <Dropdown.Toggle as="button" bsPrefix="toggle" className="nav-link px-1 nine-dots border-0 bg-transparent">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <circle cx="2" cy="2" r="2"></circle>
            <circle cx="2" cy="8" r="2"></circle>
            <circle cx="2" cy="14" r="2"></circle>
            <circle cx="8" cy="8" r="2"></circle>
            <circle cx="8" cy="14" r="2"></circle>
            <circle cx="14" cy="8" r="2"></circle>
            <circle cx="14" cy="14" r="2"></circle>
            <circle cx="8" cy="2" r="2"></circle>
            <circle cx="14" cy="2" r="2"></circle>
          </svg>
        </Dropdown.Toggle>

        {/* منوی لینک‌های سریع */}
        <Dropdown.Menu
          className="dropdown-menu-card dropdown-menu-end dropdown-caret dropdown-caret-bg"
          show={show ?? undefined}
        >
          <Card className="dropdown-menu-end shadow-none">
            <Card.Body className="nav-quick-links overflow-x-hidden p-3" style={{ height: 'auto' }}>
              <Row className="text-center g-0">
                {quickLinks.map((item, index) => (
                  <QuickLinkItem key={index} {...item} index={index} />
                ))}
              </Row>
            </Card.Body>
          </Card>
        </Dropdown.Menu>
      </Dropdown>
    </ChildrensTooltip>
  );
};

/**
 * آیتم لینک سریع داخل منوی نه نقطه.
 */
const QuickLinkItem = ({ img, title, link }: QuickLinkItemProps) => {
  return (
    <Col xs={4}>
      <a
        className="d-flex flex-column align-items-center hover-bg-200 px-2 py-2 rounded-3 text-decoration-none text-center"
        target="_blank"
        rel="noopener noreferrer"
        href={link || '!#'}
      >
        <ChildrensTooltip
          placement="top"
          html={title}
          delayToRemove={1}
          className="d-flex flex-column align-items-center w-100"
        >
          {img && <img src={img} width={40} height={40} className="mb-2" alt={title} />}
          <p
            className="mb-0 fw-medium text-800 text-truncate fs--2"
            style={{ textOverflow: 'ellipsis', width: '100%' }}
          >
            {title}
          </p>
        </ChildrensTooltip>
      </a>
    </Col>
  );
};

export default NineDotMenu;
